import { DISPLAYS } from './DisplaySettings.config';
import { DisplayType, DisplayIconType } from './DisplaySettings.types';

export const computeActiveDisplay = (display: DisplayType) =>
  DISPLAYS.map((disp) => disp === display);
export const getDisplayName = (display: DisplayIconType): string =>
  display.split('-')[1];
